package com.schoolconnect.app.feature.common

import com.schoolconnect.app.domain.SchoolKeys

fun shellRoleLabel(roleCode: String): String = when (roleCode) {
    SchoolKeys.V_ROLE_APP_SUPER_ADMIN -> "Super Admin"
    SchoolKeys.V_ROLE_APP_ADMIN -> "App Admin"
    SchoolKeys.V_ROLE_APP_BACKEND -> "App Backend"
    SchoolKeys.V_ROLE_SCHOOL_ADMIN -> "School Admin"
    SchoolKeys.V_ROLE_TEACHER -> "Teacher"
    SchoolKeys.V_ROLE_PARENT -> "Parent"
    SchoolKeys.V_ROLE_SUPPORT_STAFF -> "Support Staff"
    else -> "Super Admin"
}

fun shellRoleSubtitle(roleCode: String): String = when (roleCode) {
    SchoolKeys.V_ROLE_APP_SUPER_ADMIN -> "Super Administrator"
    SchoolKeys.V_ROLE_APP_ADMIN -> "Platform Administrator"
    SchoolKeys.V_ROLE_APP_BACKEND -> "Backend Operator"
    SchoolKeys.V_ROLE_SCHOOL_ADMIN -> "School Administrator"
    SchoolKeys.V_ROLE_TEACHER -> "Teacher"
    SchoolKeys.V_ROLE_PARENT -> "Parent"
    SchoolKeys.V_ROLE_SUPPORT_STAFF -> "Support Staff"
    else -> "Super Administrator"
}

/** Display label for school_staff.auth_role codes shown in Edit Profile. */
fun shellStaffAuthRoleLabel(authRole: String): String = when (authRole.trim().uppercase()) {
    "SCHOOL_TEACHER", "TEACHER" -> "Teacher"
    "SCHOOL_ADMIN", "ADMIN" -> "School Admin"
    "SCHOOL_MGMT", "MANAGEMENT", "SCHOOL MANAGEMENT" -> "Management"
    "SCHOOL_SUPPORT_STAFF", "SUPPORT", "SUPPORT STAFF" -> "Support Staff"
    else -> authRole.trim().ifBlank { "—" }
}

fun shellAvatarInitials(primaryLabel: String, secondaryLabel: String = ""): String {
    val words = buildList {
        add(primaryLabel)
        add(secondaryLabel)
    }
        .joinToString(" ")
        .trim()
        .split(Regex("\\s+"))
        .filter { it.isNotBlank() }

    val initials = when {
        words.size >= 2 -> "${words.first().first()}${words.last().first()}"
        words.size == 1 -> words[0].take(1)
        else -> "SC"
    }

    return initials.uppercase()
}
